import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from "react";

interface DocumentComplianceHelperContextType {
  isVisible: boolean;
  setVisible: (visible: boolean) => void;
}

const DocumentComplianceHelperContext = createContext<
  DocumentComplianceHelperContextType | undefined
>(undefined);

interface DocumentComplianceHelperProviderProps {
  children: ReactNode;
}

export const DocumentComplianceHelperProvider: React.FC<
  DocumentComplianceHelperProviderProps
> = ({ children }) => {
  const [isVisible, setVisible] = useState<boolean>(false);

  const value: DocumentComplianceHelperContextType = {
    isVisible,
    setVisible,
  };

  return (
    <DocumentComplianceHelperContext.Provider value={value}>
      {children}
    </DocumentComplianceHelperContext.Provider>
  );
};

export const useDocumentComplianceHelper =
  (): DocumentComplianceHelperContextType => {
    const context = useContext(DocumentComplianceHelperContext);
    if (context === undefined) {
      throw new Error(
        "useDocumentComplianceHelper must be used within a DocumentComplianceHelperProvider"
      );
    }
    return context;
  };

export default DocumentComplianceHelperContext;
